import { Component, ViewEncapsulation, Input, HostBinding, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NHATestDirective } from '../../directives/test/test.directive';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'nha-dialog',
	templateUrl: './dialog.component.html',
	styleUrls: ['./dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
	imports: [CommonModule, NHATestDirective, MatIconModule]
})
export class NHADialogComponent implements OnInit {
	@Input() titleIcon: string = null;
	@Input() dialogType: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' = 'primary';
	@Input() width: 'narrow' | 'mid' | 'wide' | 'extra-wide' | 'xx-wide' = null;
	@Input() notes: string[];
	@Input() hasPanel: boolean = false;
	@Input() hasContentActionBar: boolean = false;
	@Input() hasTabs: boolean = false;
	@Input() fullWidth: boolean = false;
	@Input() includeHeader: boolean = true;
	@Input() includeFooter: boolean = true;

	@HostBinding('class.has-title-icon') _hasTitleIcon: boolean = false;
	@HostBinding('class.has-notes') _hasNotes: boolean = false;
	@HostBinding('class.paneled') _hasPanel: boolean = false;
	@HostBinding('class.has-content-action-area') _hasContentActionBar: boolean = false;
	@HostBinding('class.full-width') _fullWidth: boolean = false;
	@HostBinding('class.tabbed') _hasTabs: boolean = false;

	/* Dialog Type */
	@HostBinding('class.primary') _isPrimary: boolean = false;
	@HostBinding('class.secondary') _isSecondary: boolean = false;
	@HostBinding('class.success') _isSuccess: boolean = false;
	@HostBinding('class.danger') _isDanger: boolean = false;
	@HostBinding('class.warning') _isWarning: boolean = false;
	@HostBinding('class.info') _isInfo: boolean = false;

	/*Dialog Width*/
	@HostBinding('class.width-narrow') _isWidthNarrow: boolean = false;
	@HostBinding('class.width-mid') _isWidthMid: boolean = false;
	@HostBinding('class.width-wide') _isWidthWide: boolean = false;
	@HostBinding('class.width-extra-wide') _isWidthExtraWide: boolean = false;
	@HostBinding('class.width-xx-wide') _isWidthXXWide: boolean = false;
	ngOnInit(): void {
		this._hasTitleIcon = this.titleIcon !== null && this.titleIcon.length > 0;
		this._hasNotes = this.notes && this.notes.length > 0;
		this._hasPanel = this.hasPanel;
		this._hasContentActionBar = this.hasContentActionBar;
		this._fullWidth = this.fullWidth;
		this._hasTabs = this.hasTabs;

		this._isPrimary = this.dialogType === 'primary';
		this._isSecondary = this.dialogType === 'secondary';
		this._isSuccess = this.dialogType === 'success';
		this._isDanger = this.dialogType === 'danger';
		this._isWarning = this.dialogType === 'warning';
		this._isInfo = this.dialogType === 'info';

		this._isWidthNarrow = this.width === 'narrow';
		this._isWidthMid = this.width === 'mid';
		this._isWidthWide = this.width === 'wide';
		this._isWidthExtraWide = this.width === 'extra-wide';
		this._isWidthXXWide = this.width === 'xx-wide';
	}
}
